import React, { useState, useEffect } from 'react';
import { APIProvider, Map, InfoWindow } from '@vis.gl/react-google-maps';
import { AdvancedMarker, Pin } from '@vis.gl/react-google-maps';
import { useAtom } from 'jotai';
import { allDevLocationAtom, deviceLocationAtom, DevLocation, devicePathAtom, allDeviceAtom } from '../atoms-types/devices';
import { mapCenterAtom, mapZoomAtom } from '../atoms-types/maps';
import { useParams, useNavigate } from 'react-router-dom';
import Button from "@mui/material/Button";
import { useFetchDevicePath } from '../handlers/fetchDevicePath';
import { Polyline } from '../Polyline';
import { useTheme } from '@mui/material/styles';
import { Typography, Box } from '@mui/material';
import ConvertTime from '../converters/timestampConverter';
// import MapCenterButton from '../buttons/mapCenterButtons';

const GolfMap = () => {
  const { deviceEUI } = useParams<{ deviceEUI?: string }>();
  const [devLocations, ] = useAtom(deviceEUI ? deviceLocationAtom : allDevLocationAtom);
  const [mapCenter, setMapCenter] = useAtom(mapCenterAtom);
  const [zoomState, setZoomState] = useAtom(mapZoomAtom);
  const [devicePath] = useAtom(devicePathAtom);
  const [selectedCar, setSelectedCar] = useState<DevLocation | null>(null);
  const navigate = useNavigate();
  const [, setFetchPath] = useState<boolean>(false);
  const [allDevices] = useAtom(allDeviceAtom);
  const theme = useTheme();

  console.log("golfmap", devLocations);
  console.log("GolfMap deviceEUI from useParams:", deviceEUI);

  const handleMarkerClick = (devLocation: DevLocation) => {
    setSelectedCar(selectedCar === devLocation ? null : devLocation);
  };
  
  const isValidLocation = (lat: number, lng: number) => Number.isFinite(lat) && Number.isFinite(lng);

  useEffect(() => {
    if (deviceEUI) {
      const location = devLocations.find(location => location.deviceEUI === deviceEUI);
      if (location) {
        setMapCenter({ lat: location.lat, lng: location.lng });
        setZoomState({ zoom: 20 });
        setFetchPath(true);
        console.log('Centering map to device:', location);
      }
    } else {
      setZoomState({ zoom: 17 });
      setFetchPath(false);
      setSelectedCar(null); // Clear the selected car when viewing all devices
      console.log('Displaying map normally');
    }
  }, [deviceEUI, devLocations, setMapCenter, setZoomState]);

  const { isFetching, isError, error } = useFetchDevicePath(deviceEUI ?? null);

  const getMarkerStyle = (deviceEUI: string) => {
    const device = devLocations.find(dev => dev.deviceEUI === deviceEUI);
    console.log("device: ", device);
    const devLast4 = deviceEUI?.slice(-4);
    const deviceName = device ? device.name : devLast4;
    const deviceType = device ? device.type : "car";
    if (deviceType === "fob") {
      return {
        background: 'cadetblue',
        borderColor: 'teal',
        glyph: deviceName,
      };
    } else if (deviceType === "car") {
      return {
        background: 'indianred',
        borderColor: 'firebrick',
        glyph: deviceName,
      };
    }
    return {
      background: 'grey',
      borderColor: 'grey',
      glyph: deviceName,
    };
  };

  const handleDeviceClick = (deviceID: string) => {
    navigate(`/fleet/${deviceID}`);
  };

  useEffect(() => {
    if (selectedCar) {
      const location = devLocations.find(location => location.deviceEUI === selectedCar.deviceEUI);
      if (location) {
        setMapCenter({ lat: location.lat, lng: location.lng });
        setZoomState({ zoom: 18 });
      }
    }
  }, [selectedCar, devLocations, setMapCenter, setZoomState]);

  if (isFetching) return <div>Loading...</div>;
  if (isError) return <div>Error: {error?.message}</div>;

  const mostRecentLocation = devicePath[devicePath.length - 1];

  console.log('devicePath:', devicePath);
  console.log('mostRecentLocation:', mostRecentLocation);
  console.log('deviceEUI:', deviceEUI);
  console.log('devLocations sample:', devLocations.slice(0, 2));

  return (
    <div>
      <APIProvider apiKey="AIzaSyDYZA7VHWtg3w6W0W1QDwkHAoo_MuQV_IU">
        <Map
          style={{ width: "100%", height: '750px' }}
          defaultCenter={mapCenter}
          defaultZoom={zoomState.zoom}
          mapId='MAP_ID'
          mapTypeId = 'satellite'
          onClick={() => setSelectedCar(null)}
        >
          {devLocations?.map((location: DevLocation, index: number) => {
            if (isValidLocation(location.lat, location.lng)) {
              const markerStyle = getMarkerStyle(location.deviceEUI);
              return (
                <React.Fragment key={index}>
                  <AdvancedMarker
                    position={{ lat: location.lat, lng: location.lng }}
                    onClick={() => handleMarkerClick(location)}
                  >
                    {/* <Pin
                      background={markerStyle.background}
                      borderColor={markerStyle.borderColor}
                      glyphColor={'white'}
                      glyph={markerStyle.glyph}
                      scale={1}
                    /> */}
                    <div className="custom-marker" style={{ backgroundColor: markerStyle.background, borderColor: markerStyle.borderColor }}>
                      <div className="custom-marker-text">
                        {markerStyle.glyph}
                      </div>
                    </div>
                  </AdvancedMarker>
                  {selectedCar === location && (
                    <AdvancedMarker
                      position={{ lat: location.lat, lng: location.lng }}
                    >
                      <div className="custom-info-window">
                        {/* Close button */}
                        <Button
                          onClick={() => setSelectedCar(null)}
                          className="custom-info-window-close-btn"
                        >
                          ×
                        </Button>
                        
                        {/* Header */}
                        <Typography 
                          variant="h6" 
                          className="custom-info-window-header"
                        >
                          {location.name}
                        </Typography>
                        
                        {/* Content */}
                        <Typography className="custom-info-window-content">EUI: {location.deviceEUI}</Typography>
                        <Typography className="custom-info-window-content">Type: {location.type}</Typography>
                        <Typography className="custom-info-window-content">lat: {location.lat.toFixed(3)}</Typography>
                        <Typography className="custom-info-window-content">lng: {location.lng.toFixed(3)}</Typography>
                        <Typography className="custom-info-window-content">Last Report: {ConvertTime(location.timestamp)}</Typography>
                        
                        {/* Action button */}
                        <Button 
                          variant="contained" 
                          className="custom-info-window-action-btn"
                          onClick={() => handleDeviceClick(selectedCar.deviceEUI)}
                        >
                          to device
                        </Button>
                      </div>
                    </AdvancedMarker>
                  )}
                </React.Fragment>
              );
            }
            return null;
          })}
          {deviceEUI && devicePath.length > 0 && (
            <>
              <Polyline
                path={devicePath.map(({ lat, lng }) => ({ lat, lng }))}
                strokeColor={'goldenrod'}
              />
              {isValidLocation(mostRecentLocation.lat, mostRecentLocation.lng) && (
                <AdvancedMarker
                  position={{ lat: mostRecentLocation.lat, lng: mostRecentLocation.lng }}
                  onClick={() => handleMarkerClick(mostRecentLocation)}
                >
                  <div className="custom-marker" style={{ backgroundColor: getMarkerStyle(deviceEUI).background, borderColor: getMarkerStyle(deviceEUI).borderColor }}>
                    <div className="custom-marker-text">
                      {mostRecentLocation?.name || deviceEUI?.slice(-4) || 'DEV'}
                    </div>
                  </div>
                </AdvancedMarker>
              )}
            </>
          )}
        </Map>
      </APIProvider>
      {deviceEUI && (
        <Button
          onClick={() => navigate('/fleet/map')}
          style={{
            backgroundColor: 'seagreen',
            color: 'white'
          }}
        >
          View All Devices
        </Button>
      )}
      {/* <MapCenterButton /> */}
    </div>
  );
};

export default GolfMap;


